export default {
    config: {
        defaultWidth: {
            default: 80,
            sheet: 160
        },
    },
    default: {
        label: 'Updated'
    },
    unique: [],
    sort: 'collection.updated',
    lang: {
        name: 'Date Updated in Collection',
        category: ['User', 'Collection'],
        description: 'When the game was updated in the collection.',
        views: ['list', 'sheet', 'grid'],
    },
    filters: ['collection.updated']
}